import type { CustomerType } from "@origin-digital/sales-cart";

import { BUSINESS_PATH } from "../consts";

export const isBusinessPage = () => {
  const { pathname } = window.location;
  return pathname === BUSINESS_PATH || pathname.startsWith(`${BUSINESS_PATH}/`);
};

export const getCustomerType = (): CustomerType =>
  isBusinessPage() ? "business" : "residential";

export const getMoveCustomerType = (customerClass?: string): CustomerType =>
  customerClass === "SME" ? "business" : getCustomerType();
